"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaDiaAula = exports.yupDiaAula = void 0;
const yup = __importStar(require("yup"));
const date_fns_1 = require("date-fns");
const utils_1 = require("../utils");
exports.yupDiaAula = yup.object({
    id: yup.number().notRequired().nullable().default(null),
    data: (0, utils_1.sge2Date)().required().default((0, date_fns_1.format)(new Date(), 'yyyy-MM-dd')).label('Data'),
    aula: yup.string().required().max(2).default(''),
    descricao: yup.string().notRequired().nullable().default(''),
    tarefa: yup.string().notRequired().nullable().default(''),
    diaSemAula: yup.boolean().required().default(false),
    inutilizaDia: yup.boolean().required().default(false),
    idCurso: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Curso'),
    idSerie: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Série'),
    idTurma: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Turma'),
    idMateria: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Materia'),
    idProfessor: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Professor'),
    idUsuario: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Usuario'),
    idMensagem: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Mensagem'),
});
exports.schemaDiaAula = exports.yupDiaAula.shape({});
